import { render, staticRenderFns } from "./lager.vue?vue&type=template&id=98e89ea0&scoped=true&"
import script from "./lager.vue?vue&type=script&lang=js&"
export * from "./lager.vue?vue&type=script&lang=js&"
import style0 from "./lager.vue?vue&type=style&index=0&id=98e89ea0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98e89ea0",
  null
  
)

export default component.exports